import React, { useEffect } from 'react'

import { PlatformEnum } from '@vacationtracker/shared/data/platforms'

import SignupWithAnotherPlatformModal from './signup-with-another-platform-modal'

import { trackSignup } from '../analytics'
import { ISignupModals } from '../hooks/use-signup-modals'
import { ConnectPlatform } from '../types'

export interface ISignupModalsProps {
  modals: ISignupModals
  /** The modals hand back whatever platform the backend named, so this takes the wider type. */
  onConnectWithPlatform: (platform: PlatformEnum) => void
  onSignupWithEmail: () => void
  onSigninWithPlatform: (platform: ConnectPlatform) => void
}

/** Every modal the page can open. */
const SignupModals = ({ modals, onConnectWithPlatform, onSignupWithEmail, onSigninWithPlatform }: ISignupModalsProps): React.ReactElement => {
  const { state } = modals
  const { domainPlatform } = state

  // Reported where it reaches the screen, the way the banners are. Closing it sends nothing:
  // shown without one of the three choices below is that number.
  useEffect(() => {
    if (domainPlatform) {
      trackSignup('SIGNUP_DOMAIN_PLATFORM_MODAL_SHOWN', { domainPlatform })
    }
  }, [domainPlatform])

  return (
    <>
      {domainPlatform && (
        <SignupWithAnotherPlatformModal
          domainPlatform={domainPlatform}
          connectWithPlatform={(platform) => {
            trackSignup('SIGNUP_DOMAIN_PLATFORM_MODAL_SIGNUP_CLICKED', { platform, domainPlatform })
            onConnectWithPlatform(platform as PlatformEnum)
          }}
          handleSignupWithMail={() => {
            trackSignup('SIGNUP_DOMAIN_PLATFORM_MODAL_EMAIL_CLICKED', { domainPlatform })
            onSignupWithEmail()
          }}
          handleSigninWithPlatform={(platform) => {
            trackSignup('SIGNUP_DOMAIN_PLATFORM_MODAL_SIGNIN_CLICKED', { platform, domainPlatform })
            onSigninWithPlatform(platform)
          }}
          handleClose={modals.hideSignupWithAnotherPlatform}
        />
      )}
    </>
  )
}

export default SignupModals
